// extracted by mini-css-extract-plugin
export default {"quotePage":"QuotePage_quotePage__0x+-X","typingArea":"QuotePage_typingArea__uqbYl","buttonsWrapper":"QuotePage_buttonsWrapper__tf86r"};